(function (w) {
  var tagEnv = "prod";
  if (w.location.host.indexOf("qa") > -1) {
    tagEnv = "qa";
  } else if (w.location.host.indexOf("dev") > -1) {
    tagEnv = "dev";
  }
  var src =
    tagEnv === "prod"
      ? "https://onetms.capitalone.com/ot/ot.js"
      : "https://onetms-qa.capitalone.com/ot/ot.js";
  var script = document.createElement("script");
  script.setAttribute("src", src);
  script.setAttribute("async", true);
  script.setAttribute("type", "text/javascript");
  document.head.appendChild(script);
  w.oneTagConfig = {
    oneTagProfile: "others",
    oneTagEnv: tagEnv,
    autotracker: false,
    app_id: "iterative-app",
  };
})(window);
